import { useState } from 'react'


import { Tooltip, IconChevronLeft, IconChevronRight, Button } from '@/components'
import { SystemStatusEnum } from '@/enums'
import { SystemStatus } from '@/models'
import { MonitoringSummaryDataType, FormChangeEventHandler } from '@/types'

interface SystemStatusesCarouselProps {
    statuses: SystemStatus[]
    summary: MonitoringSummaryDataType
    'data-test'?: string

    onChange: FormChangeEventHandler
}

const MAX_VISIBLE_STATUSES = 6

export const SystemStatusesCarousel = ({
    statuses,
    summary,
    'data-test': dataTest,
    onChange
}: SystemStatusesCarouselProps) => {
    const [startIndex, setStartIndex] = useState(0)

    const filteredStatuses = statuses.filter(status => !!summary.statuses_count[status.value])
    const visibleStatuses = filteredStatuses.slice(startIndex, startIndex + MAX_VISIBLE_STATUSES)

    const handlePrev = () => {
        setStartIndex(prev => prev - 1)
    }

    const handleNext = () => {
        setStartIndex(prev => prev + 1)
    }

    const handleStatusClick = (status: SystemStatus) => {
        onChange({
            target: {
                name: 'statuses',
                value: [status.value as SystemStatusEnum]
            }
        })
    }

    return <div className="flex items-center" data-test={dataTest}>
        {startIndex > 0 && <Button
            onClick={handlePrev}
            design="btn-link"
            data-test={`${dataTest}-previous-button`}
        >
            <IconChevronLeft className="stroke-primary-600"/>
        </Button>}
        {visibleStatuses.map(status =>
            <Tooltip
                className="hover:z-10 -ml-0.5"
                key={status.value}
                content={`${status.title} (${summary.statuses_count[status.value]?.format()})`}
            >
                <Button
                    onClick={() => handleStatusClick(status)}
                    className="rounded-full block cursor-pointer"
                    data-test={`${dataTest}-${status.value}-icon`}
                    design="btn-link"
                >
                    {status.iconBadge('xs')}
                </Button>
            </Tooltip>)}
        {startIndex + MAX_VISIBLE_STATUSES < filteredStatuses.length && <Button
            onClick={handleNext}
            design="btn-link"
            data-test={`${dataTest}-next-button`}
        >
            <IconChevronRight className="stroke-primary-600"/>
        </Button>}
    </div>
}
